import { Loader } from '@nordlayer/rivendell-ui';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { SERVER_LIST_PATH, SERVER_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var ServersListOld = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ServersListOld');
});
var ServerList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ServerList');
});
var Server = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/Server');
});
export var ServersRouting = function ServersRouting(_ref) {
    var areFeaturesLoaded = _ref.areFeaturesLoaded, isServersRedesignEnabled = _ref.isServersRedesignEnabled;
    var getListPage = function getListPage() {
        if (!areFeaturesLoaded) {
            return /*#__PURE__*/ _jsx(Loader, {
                centered: true
            });
        }
        return isServersRedesignEnabled ? /*#__PURE__*/ _jsx(ServerList, {}) : /*#__PURE__*/ _jsx(ServersListOld, {});
    };
    return RouteGenerator({
        list: {
            path: SERVER_LIST_PATH,
            component: function component() {
                return getListPage();
            },
            exact: true
        },
        single: {
            path: SERVER_PATH,
            component: Server,
            exact: false
        }
    });
};
